import { Component, Input } from '@angular/core';

@Component({
  selector: 'kion-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss']
})
export class PriceComponent {

  @Input() price: string;
  @Input() strikedPrice: string;
  @Input() isRanged = false;
  @Input() type: 'small' | 'medium' | 'large' | 'extra-large' | string = 'large';
  @Input() sameLine = false;
  @Input() priceOnRequest: string;

}
